module.exports = __webpack_public_path__ + "static/media/Back.49fc14ab.svg";